import { Component, ChangeDetectionStrategy } from '@angular/core';
//
import { TranslateService } from '@services';
//
import { CommonNavDatum } from '@common2/components/nav/nav.component';
import { PageHubModel } from '@models/page-hub.model';
import { ORGANIZE_MARKETPLACE_NAV_KEY_LIST } from '@modules/organize/organize.constants';

@Component({
    selector: 'msc-organize-marketplace-page',
    templateUrl: './organize-marketplace-page.component.html',
    styleUrls: ['./organize-marketplace-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class OrganizeMarketplacePageComponent extends PageHubModel {
    constructor(
        private readonly translateService: TranslateService,
    ) {
        super();
    }

    ngOnInit(): void {
        this.setNav();
    }

    /**
     * Get the nav data of the page
     */
    getNav(): Array<CommonNavDatum> {
        return ORGANIZE_MARKETPLACE_NAV_KEY_LIST.map((key) => ({
            label: this.translateService.instant(`organize.marketplace.nav.${key}`),
            value: {
                routerLink:  `./${key}`,
            }
        }));
    }
}
